module.exports = __webpack_public_path__ + "static/media/16th_A.08ab1163.png";